import { assert } from '@varos/util-typescript';
export function createCountRepository(config) {
    const { repository, client } = config;
    function getCountLookupQueryKey(props) {
        return ['research', 'count', 'lookup', props.kind, props.scope];
    }
    return {
        useLookup(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: getCountLookupQueryKey(props),
                async queryFn() {
                    const response = await client.user.default.countList({
                        kind: 'collection.total',
                        scope: props.scope,
                    });
                    const [count, ...rest] = response.data.data;
                    assert(count, 'expected count');
                    assert(rest.length === 0, 'expected single count');
                    return count;
                },
            });
            return query;
        },
    };
}
//# sourceMappingURL=countRepository.js.map